import { Nav } from '@/components/Nav';
import { ScrollProgress } from '@/components/ScrollProgress';
import { SmoothScroll } from '@/components/SmoothScroll';
import { ThemeProvider } from '@/lib/theme';
import { WasmProvider } from '@/lib/useSlobozip';
import { Open } from '@/components/sections/Open';
import { Squeeze } from '@/components/sections/Squeeze';
import { Trace } from '@/components/sections/Trace';
import { Anatomy } from '@/components/sections/Anatomy';
import { Threads } from '@/components/sections/Threads';
import { Trail } from '@/components/sections/Trail';
import { Surfaces } from '@/components/sections/Surfaces';
import { Signoff } from '@/components/sections/Signoff';

/**
 * Page composition — the eight sections, all live.
 *
 *   1. Open     — cinematic hero with the ambient byte stream
 *   2. Squeeze  — WASM-backed compression demo
 *   3. Trace    — pinned-scroll algorithm theatre
 *   4. Anatomy  — drenched plate, .slbz cross-section
 *   5. Threads  — multi-thread benchmark race
 *   6. Trail    — roadmap, layered terrain with parallax
 *   7. Surfaces — four-platform gallery
 *   8. Sign-off — drenched closing plate
 */
export default function App() {
  return (
    <ThemeProvider>
      <WasmProvider>
        <SmoothScroll>
          <ScrollProgress />
          <Nav />
          <main>
            <Open />
            <Squeeze />
            <Trace />
            <Anatomy />
            <Threads />
            <Trail />
            <Surfaces />
            <Signoff />
          </main>
        </SmoothScroll>
      </WasmProvider>
    </ThemeProvider>
  );
}
